var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactEmailIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 4L5.94218 6.61131C7.64123 7.574 8.3591 7.574 10.0582 6.61131L14.6668 4",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34401 8.98371C1.38759 11.0274 1.40938 12.0492 2.16347 12.8062C2.91755 13.5632 3.96705 13.5895 6.06605 13.6422C7.3597 13.6748 8.64063 13.6748 9.9343 13.6422C12.0333 13.5895 13.0828 13.5632 13.8369 12.8062C14.591 12.0492 14.6128 11.0274 14.6563 8.98371C14.6704 8.32658 14.6704 7.67338 14.6563 7.01625C14.6128 4.97255 14.591 3.95071 13.8369 3.19375C13.0828 2.4368 12.0333 2.41043 9.9343 2.35769C8.64063 2.32519 7.3597 2.32519 6.06604 2.35769C3.96705 2.41042 2.91755 2.43679 2.16346 3.19375C1.40938 3.9507 1.38759 4.97255 1.344 7.01625C1.32999 7.67338 1.33 8.32658 1.34401 8.98371Z",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmailIc);
export default __webpack_public_path__ + "static/media/contact_email_ic.76699a717b8189900292c07102b2fd10.svg";
export { ForwardRef as ReactComponent };